import React, { Component, Fragment } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Form } from 'semantic-ui-react';

import { FieldEnum } from 'Common/FieldEnum';
import { renderField } from 'Common/FormHelper';
import { SelectField } from 'Common/SemanticWrapper';
import { getFiscalYear } from 'Common/GeneralHelper';
import { IMPORT_LICENSE_FORM } from 'Common/FormEnum';

class LicenseForm extends Component {
  renderFiscalYear() {
    if (!this.props.displayFiscalYear) {
      return null;
    }

    let transformedData = [];
    const currentFiscalYear = getFiscalYear(new Date());

    transformedData.push({
      key: currentFiscalYear,
      text: currentFiscalYear,
      value: currentFiscalYear,
    });

    transformedData.push({
      key: currentFiscalYear + 1,
      text: currentFiscalYear + 1,
      value: currentFiscalYear + 1,
    });

    return (
      <Fragment>
        <label>Starting Fiscal Year</label>
        <Field
          name={FieldEnum.FiscalYear}
          component={SelectField}
          type={'text'}
          placeholder={'Starting Fiscal Year'}
          options={transformedData}
        />
      </Fragment>
    );
  }

  onChange = e => {
    if (e.target.value.length > 0) {
      this.props.clearLicenseErrors();
    }
  };

  render() {
    return (
      <Form>
        {this.renderFiscalYear()}
        <label>Upload your license file</label>
        <Field
          name={'license_file'}
          component={renderField}
          type={'file'}
          onChange={this.onChange}
          accept={'.mpx'}
        />
      </Form>
    );
  }
}

export default reduxForm({
  form: IMPORT_LICENSE_FORM,
})(LicenseForm);



// WEBPACK FOOTER //
// ./src/pages/license/components/LicenseForm.js